import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CrmSearchService {

  constructor(private http: HttpClient) { }

    url1 = environment.serverAPI9 + '/' + 'api/leadOwnerSearch';

    url2 = environment.serverAPI9 + '/' + 'api/companyOwnerSearch';

    url3 = environment.serverAPI9 + '/' + 'api/dealsOwnerSearch';

  getAllCrmLeadSearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url1}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

  getAllCrmCompanySearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url2}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

  getAllCrmDealsSearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url3}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

}
